import { ClimbingArea } from "../types";

const STORAGE_KEY = 'cw_area_history';
const MAX_HISTORY_ITEMS = 10;

interface AreaHistoryItem {
  areaId: string;
  name: string;
  adminAreaName: string;
  lastViewed: number;
  viewCount: number;
}

export function trackAreaView(area: ClimbingArea): void {
  try {
    const history = getAreaHistory();
    const existingIndex = history.findIndex(item => item.areaId === area.areaId);

    if (existingIndex >= 0) {
      // Update existing entry
      history[existingIndex].lastViewed = Date.now();
      history[existingIndex].viewCount += 1;
      // Move to front
      const [item] = history.splice(existingIndex, 1);
      history.unshift(item);
    } else {
      // Add new entry at the front
      history.unshift({
        areaId: area.areaId,
        name: area.name,
        adminAreaName: area.adminAreaName,
        lastViewed: Date.now(),
        viewCount: 1,
      });
    }

    // Keep only the most recent items
    const trimmedHistory = history.slice(0, MAX_HISTORY_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmedHistory));
  } catch (error) {
    // Silently fail if localStorage is not available
    console.warn('Could not save area history:', error);
  }
}

export function getAreaHistory(): AreaHistoryItem[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return [];
    }
    return JSON.parse(stored);
  } catch (error) {
    console.warn('Could not read area history:', error);
    return [];
  }
}

export function getRecentlyViewedAreas(limit: number = 5): AreaHistoryItem[] {
  const history = getAreaHistory();
  // Already sorted by most recent (items are added to front)
  return history.slice(0, limit);
}
